import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-graphite px-3 py-4 sm:px-6" data-id="element-52" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-53" data-mp="1hdup6krjl7as">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-white sm:text-[2rem]" data-id="element-54" data-mp="1cf04tedxfaok">
          FREQUENTLY ASKED <span className="text-hazard" data-id="element-55" data-mp="2a1h0ygaxbi8q">QUESTIONS</span>
        </h2>
        <ul className="mt-2 space-y-1.5" data-id="element-56" data-mp="252vw23kq8ady">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className={`overflow-hidden rounded-md border bg-ink transition-colors duration-150 ease-out ${isOpen ? 'border-hazard' : 'border-line'}`} data-id="element-57" data-mp="2028156tdn9eg" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-2 px-2.5 py-2 text-left font-display text-[0.78rem] font-bold text-white transition-colors duration-150 ease-out hover:text-hazard focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-hazard sm:text-[0.9rem]" data-id="element-58" data-mp="jpjgartfgdxm">
                  {f.q}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-hazard transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-59" data-mp="11ve7e5sc76g5" />
                </button>
                {isOpen ? <p id={`faq-${i}`} className="px-2.5 pb-2 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.88rem]" data-id="element-60" data-mp="wyfdnocl51ih">
                    {f.a}
                  </p> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}